// @flow
import React, { useState, useEffect } from 'react';

import Card from '../../../components/Cards/Card';

import styles from './ArticlesSave.module.scss';
import getDatahtPlo5 from '../../../controllers/handtipsPlo5.controller';

type IHT = {
  header: {
    textheader: string;
  };

  Content: {
    subtitle: string,
    blockOne: {
      blockHeaderOne: string;
      textboone: string;
      textbotwo: string;
    };
    blockTwo: {
      blockHeaderTwo: string;
      textbtone: string;
      textbttwo: string;
      textbtthree: string;
    };
    blockThree: {
      blockHeaderThree: string;
      textbthone: string;
      textbthtwo: string;
      textbththree: string;
      textbthfour: string;
      textbthfive: string;
      textbthsix: string;
      textbthseven: string;
      textbtheight: string;
      textbthnine: string;
      textbthten: string;
      textbtheleven: string;
      textbthtwelve: string;
      textbththirteen: string;
      textbthfourteen: string;
      textbthfifteen: string;
      textbthsixteen: string;
      textbthseventeen: string;
    };
    blockFour: {
      blockHeaderFour: string;
      textbfone: string;
      textbtwo: string;
      textbthree: string;
      textbffour: string;
    };
  };
} | null

const HandtipsPlo5 = () => {
  const [language, setLanguage] = useState<string>('');

  const [data, setData] = useState<IHT>({});

  const getLanguage = () => {
    const locale = localStorage.getItem('i18nextLng');
    let languageKey;
    switch (locale) {
      case 'en':
        languageKey = 'Eng';
        break;
      case 'ru':
        languageKey = 'Rus';
        break;
      default:
        languageKey = 'Rus';
    }
    return languageKey;
  };

  useEffect(() => {
    setLanguage(getLanguage());
  }, []);

  const handleRes = async () => {
    const res = await getDatahtPlo5(getLanguage());
    setData(res);
  };

  useEffect(() => {
    handleRes();
  }, []);

  if (!data) return null;

  return (
    language
    && (
      <div id="root" className={styles.site}>
        <div className={`${styles.container} ${styles.minHI}`}>
          <div className={`${styles.header} ${styles.bg_header} ${styles.header_plo5}`}>
            <span className={styles.header_text}>{data.header?.textheader}</span>
          </div>
          <div className={`${styles.content} ${styles.content_plo5}`}>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.subtitle}
              </div>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.good_suit}`}>
                {data.Content?.blockOne.blockHeaderOne}
              </span>
              <div className={styles.text}>
                {data.Content?.blockOne.textboone}
              </div>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="3" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="Q" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                  <Card mast="no" bg="blank" size="big" value="9" />
                  <Card mast="no" bg="blank" size="big" value="8" />
                  <Card mast="no" bg="blank" size="big" value="7" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="4" />
                  <Card mast="no" bg="blank" size="big" value="3" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                  <Card mast="no" bg="blank" size="big" value="6" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="4" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="6" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="4" />
                  <Card mast="no" bg="blank" size="big" value="3" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockOne.textbotwo}
              </div>
            </div>
            <div className={styles.sum}>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="3" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="Q" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="9" />
                  <Card mast="no" bg="blank" size="big" value="8" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="7" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="4" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="3" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="6" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="4" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="6" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="4" />
                  <Card mast="no" bg="blank" size="big" value="3" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.bad_suit}`}>
                {data.Content?.blockTwo.blockHeaderTwo}
              </span>
              <div className={styles.text}>
                {data.Content?.blockTwo.textbtone}
              </div>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="2" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                  <Card mast="no" bg="blank" size="big" value="6" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="4" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="9" />
                  <Card mast="no" bg="blank" size="big" value="9" />
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                  <Card mast="no" bg="blank" size="big" value="Q" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="no" bg="blank" size="big" value="3" />
                  <Card mast="no" bg="blank" size="big" value="3" />
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockTwo.textbttwo}
              </div>
            </div>
            <div className={styles.sum}>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="5" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="2" />
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="6" />
                  <Card mast="no" bg="blank" size="big" value="5" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="4" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="J" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="T" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="9" />
                  <Card mast="no" bg="blank" size="big" value="9" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="A" />
                  <Card mast="no" bg="blank" size="big" value="K" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="Q" />
                </div>
              </div>
              <div className={styles.block_sum_plo5}>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="3" />
                  <Card mast="no" bg="blank" size="big" value="3" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="J" />
                  <Card mast="no" bg="blank" size="big" value="T" />
                </div>
                <span className={styles.sum_text}>+</span>
                <div className={styles.two_cards}>
                  <Card mast="no" bg="blank" size="big" value="2" />
                </div>
              </div>
            </div>
            <div className={styles.bg_block}>
              <span className={`${styles.text} ${styles.inlineBox}`}>
                {data.Content?.blockTwo.textbtthree}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
              </span>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.good_suit}`}>
                {data.Content?.blockThree.blockHeaderThree}
              </span>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthone}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthtwo}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbththree}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthfour}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthfive}
              </div>
            </div>
            <div className={styles.bg_block}>
              <span className={`${styles.text} ${styles.inlineBox}`}>
                {data.Content?.blockThree.textbthsix}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="Q" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
              </span>
            </div>
            <div className={styles.block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthseven}
              </div>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="Q" />
                  <Card mast="bubi" bg="grey" size="big" value="J" />
                  <Card mast="picki" bg="black" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="Q" />
                  <Card mast="kresti" bg="green" size="big" value="J" />
                  <Card mast="bubi" bg="grey" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="Q" />
                  <Card mast="kresti" bg="green" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="Q" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="picki" bg="black" size="big" value="2" />
                </div>
              </div>
            </div>
            <div className={styles.block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbtheight}
              </div>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="Q" />
                  <Card mast="bubi" bg="grey" size="big" value="J" />
                  <Card mast="picki" bg="black" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="Q" />
                  <Card mast="kresti" bg="green" size="big" value="J" />
                  <Card mast="kresti" bg="green" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="Q" />
                  <Card mast="bubi" bg="grey" size="big" value="J" />
                  <Card mast="bubi" bg="grey" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="kresti" bg="green" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="Q" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="2" />
                </div>
              </div>
            </div>
            <div className={styles.block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthnine}
              </div>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="Q" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="2" />
                </div>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthten}
              </div>
            </div>
            <div className={styles.bg_block}>
              <span className={`${styles.text} ${styles.inlineBox}`}>
                {data.Content?.blockThree.textbtheleven}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
                {data.Content?.blockThree.textbthtwelve}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
              </span>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbththirteen}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="J" />
                  <Card mast="kresti" bg="green" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="bubi" bg="grey" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="chervi" bg="red" size="big" value="2" />
                </div>
                <span className={`${styles.text} ${styles.text_center}`}>{data.Content?.blockThree.textbthfourteen}</span>
              </div>
            </div>
            <div className={styles.block}>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="picki" bg="black" size="big" value="A" />
                  <Card mast="kresti" bg="green" size="big" value="A" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="2" />
                </div>
                <span className={`${styles.text} ${styles.text_center}`}>{data.Content?.blockThree.textbthfifteen}</span>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthsixteen}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockThree.textbthseventeen}
              </div>
            </div>
            <div className={styles.block}>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="bubi" bg="grey" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="J" />
                  <Card mast="kresti" bg="green" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="bubi" bg="grey" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="bubi" bg="grey" size="big" value="2" />
                </div>
                <span className={`${styles.text} ${styles.text_center}`}>{data.Content?.blockThree.textbthfourteen}</span>
              </div>
            </div>
            <div className={styles.block}>
              <div className={styles.card_box_plo5}>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="bubi" bg="grey" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="2" />
                </div>
                <div className={styles.hand_plo5}>
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="bubi" bg="grey" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="bubi" bg="grey" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="2" />
                </div>
                <span className={`${styles.text} ${styles.text_center}`}>{data.Content?.blockThree.textbthfifteen}</span>
              </div>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.bad_suit}`}>
                {data.Content?.blockFour.blockHeaderFour}
              </span>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockFour.textbfone}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockFour.textbftwo}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockFour.textbfthree}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content?.blockFour.textbffour}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default HandtipsPlo5;
